import React from "react";

export const SettingScreen = () => {
  return <h2>화면 설정</h2>;
};
